import wrapAngularHttpTimeout from './wrapAngularHttpTimeout';

export default wrapAngularHttpTimeout;
